import React, {useEffect, useState} from "react";


import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {generateRandomString} from "../../utilities/randomGenerator";



function MfxOutputPanel({mfxList,setMfxList,  saveMfx, selectedDate}) {
    const deleteTemplate = (rowData, options) => {
        const icon = 'pi pi-trash'
        const deleteRow = (rowData) => {
            let _data = mfxList.filter(item => item.id !== rowData.id);
                setMfxList(_data);

        };
        return <Button type="button" icon={icon} className="p-button-sm p-button-text"
                       disabled={rowData.posted}
                       onClick={() => deleteRow(rowData)}/>;
    };
    return (
        <>
            <div className=" container-fluid w-full border-2 border-gray-300 rounded-md p-2">
                <DataTable value={mfxList} resizableColumns className="p-datatable-striped p-datatable-gridlines"
                           size={"small"} style={{fontSize: '9px'}}
                           editMode="cell"
                           tableStyle={{minWidth: '30rem'}} stripedRows showGridlines={true} scrollable
                           scrollHeight="400px">

                    <Column field="code" header="Code" alignHeader="left" headerStyle={{backgroundColor: '#fff0f0'}} className="w-5"></Column>
                    <Column field="itemName" header="Item" alignHeader="left" headerStyle={{backgroundColor: '#fff0f0'}} className="w-4"/>
                   <Column field="quantity" header="Quantity" alignHeader="right" headerStyle={{backgroundColor: '#fff0f0'}} className="w-2" />
                    <Column field="remove" header="Remove" body={deleteTemplate} alignHeader="center" headerStyle={{backgroundColor: '#fff0f0'}} className="w-1" ></Column>
                </DataTable>
            </div>
            < div className=" container-fluid w-4 mt-2">
                <Button label="Save" icon="pi pi-save" className="p-button-raised p-button-success"
                        onClick={() => saveMfx(mfxList)}/>
            </div>
        </>
    )
}

export default MfxOutputPanel;
